import { Component, OnInit } from "@angular/core";
import { SideNavBarVisibilityService } from "src/app/services/side-nav-bar-visibility.service";
import { Router } from "@angular/router";
import { ZpDataService } from "../../services/zp-data.service";
import { ChartDataset, ChartType } from "chart.js";
import { ThemeService } from "src/app/theme/theme-service.service";

@Component({
    selector: "app-analytics",
    templateUrl: "./analytics.component.html",
    styleUrls: ["./analytics.component.scss"],
    standalone: false
})
export class AnalyticsComponent implements OnInit {
  public chosenTab: any;
  public stats = undefined;
  public pieLabels = [];
  public pieChartType: ChartType = "pie";
  public lineChartType: ChartType = "line";
  public barChartType: ChartType = "bar";
  public lineChartDataSets: ChartDataset[];
  public popularSectionsDataSets: ChartDataset[];
  public popularSectionsLabels: string[];
  public pieData = [];

  // public donutColors = [
  //   {
  //     backgroundColor: [
  //       "#34274D",
  //       "#471A66",
  //       "#5C4A7E",
  //       "#BCB7C8",
  //       "#EFEEF8",
  //       "#FFEED6",
  //       "#EBD4C5",
  //       "#98ABB6",
  //     ],
  //   },
  // ];
  public planItemCountDataSets: ChartDataset[];
  public planItemCountLabels: string[];

  constructor(
    private router: Router,
    public sideNavBarVisibilityService: SideNavBarVisibilityService,
    public api: ZpDataService,
    public themeService: ThemeService
  ) {}

  async ngOnInit() {
    this.openTab(null, "overview");
    this.stats = await this.api.getAnalyticsStats();
    let datasets = {};
    let tempDateSet = {};

    //prep acquisition totals:
    this.stats.acquisition.totals.map((stat) => {
      if (!datasets[stat._id.userType]) {
        datasets[stat._id.userType] = [];
      }
      let d: any = new Date(stat._id.month + "/01/" + stat._id.year);

      let s = d.toUTCString();
      datasets[stat._id.userType].push({ y: stat.count, x: s });
      tempDateSet[d * 1 + ""] = s;
    });

    let pieData = [];

    let format = new Intl.DateTimeFormat("en", { month: "short" });
    this.pieLabels = Object.keys(tempDateSet)
      .sort()
      .map((date: any) => {
        let d = new Date(date * 1);
        return format.format(d) + " " + d.getUTCFullYear();
      });
    let keys = Object.keys(datasets);
    this.lineChartDataSets = [];
    keys.map((i) => {
      let ev = datasets[i];
      this.lineChartDataSets.push({ data: datasets[i], label: i + " users" });
    });

    //prep planItemCountDataSets
    this.planItemCountDataSets = [];
    this.planItemCountLabels = [];
    let planItemCounts = [];
    this.planItemCountDataSets.push({ label: "Plans", data: planItemCounts });
    this.stats.engagement.planItemsTotals.map((stat) => {
      planItemCounts.push({ y: stat.planCount, x: stat.itemCount });
      this.planItemCountLabels.push(stat.itemCount + " items");
    });

    //prep popularSectionsDataSets
    this.popularSectionsDataSets = [];
    this.popularSectionsLabels = [];
    let popularSectionItems = [];
    this.popularSectionsDataSets.push({
      label: "Items added",
      data: popularSectionItems,
    });
    this.stats.engagement.popularSections.map((stat) => {
      popularSectionItems.push({ y: stat.itemCount, x: stat._id });
      this.popularSectionsLabels.push(stat._id);
    });
  }

  openTab(evt, tabName) {
    this.chosenTab = tabName;
    let i, tabcontent;
    tabcontent = document.getElementsByClassName("tabcontent");
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = "none";
    }
    document.getElementById(tabName).style.display = "block";
  }
}
